import axios from 'axios';

// Environment-specific configuration
const isDevelopment = process.env.NODE_ENV === 'development';

// Base URLs for different environments
const API_BASE_URL = isDevelopment 
  ? 'http://localhost:10000' 
  : 'https://moodcraftbackend.onrender.com';

// Create axios instance with default config
export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});



// Add request interceptor to include auth token
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// API endpoints
// Add these endpoints to the ENDPOINTS object
// ENDPOINTS object
export const ENDPOINTS = {
  // Auth endpoints
  AUTH: {
    LOGIN: '/api/users/login',
    REGISTER: '/api/users',
    PROFILE: '/api/users/profile',
    FORGOT_PASSWORD: '/api/users/forgot-password',
    RESET_PASSWORD: '/api/users/reset-password',
    STATS: '/api/users/stats',
    SETTINGS: '/api/users/settings',
    ACHIEVEMENTS: '/api/users/achievements',
    UPLOAD_PROFILE_PICTURE: '/api/users/upload-profile-picture',
  },
  JOURNALS: '/api/journals',
  MOODS: '/api/moods',
  AI: '/api/ai',
  CONTACT: '/api/contact',
  CREATIVE_CRAFTS: '/api/creative-Crafts',
  UPLOAD_MEDIA: '/api/uploads/media',
  AI_IMAGE: '/api/ai/imaging',
  METRICS_HOME_VISIT: '/api/metrics/visits/home', // added
};